'use client';

import { PropsWithChildren } from 'react';
import { AsyncActionResponse } from '@pioz/mlm-common';
import { toast } from 'react-hot-toast';
import { TransitionButton } from './TransitionButton';

export function DocumentDownloadButton({
  disabled,
  fetch,
  fileName,
  children,
  className,
}: PropsWithChildren<{
  disabled?: boolean;
  fetch: () => AsyncActionResponse<string>;
  fileName: string;
  className?: string;
}>) {
  return (
    <TransitionButton
      type="button"
      disabled={disabled}
      className={className}
      onClick={async () => {
        const response = await fetch();

        if ('error' in response) {
          toast.error(response.error.message);
          return;
        }

        const a = document.createElement('a');
        a.href = response.success;
        a.setAttribute('download', fileName);
        a.click();
      }}
    >
      {children}
    </TransitionButton>
  );
}
